import { TagColor } from '@factorialco/deprecated-design-system'

import { statusTranslation } from './dynamicTranslations'

export const getStatusConfig = (status: string, hasInhousePayroll = false) => {
  if (hasInhousePayroll) {
    const inhouseStatusMap: Record<string, { type: string; label: string }> = {
      'to-do': { type: 'neutral', label: statusTranslation(status, false, hasInhousePayroll) },
      doing: { type: 'warning', label: statusTranslation(status, false, hasInhousePayroll) },
      done: { type: 'positive', label: statusTranslation(status, false, hasInhousePayroll) },
      discarded: { type: 'critical', label: statusTranslation(status, false, hasInhousePayroll) },
    }

    return (
      inhouseStatusMap[status] || {
        type: 'neutral',
        label: statusTranslation(status, false, hasInhousePayroll),
      }
    )
  }

  const statusMap: Record<string, { type: string; label: string }> = {
    'in-preparation': {
      type: 'neutral',
      label: statusTranslation(status, false, hasInhousePayroll),
    },
    'to-do': { type: 'info', label: statusTranslation(status, false, hasInhousePayroll) },
    doing: { type: 'warning', label: statusTranslation(status, false, hasInhousePayroll) },
    done: { type: 'positive', label: statusTranslation(status, false, hasInhousePayroll) },
    discarded: { type: 'critical', label: statusTranslation(status, false, hasInhousePayroll) },
  }

  return (
    statusMap[status] || {
      type: 'neutral',
      label: statusTranslation(status, false, hasInhousePayroll),
    }
  )
}

export const getBookkeeperStatusTagColor = (
  status: string,
  hasInhousePayroll = false
): TagColor => {
  const statusConfig = getStatusConfig(status, hasInhousePayroll)

  const typeMap: Record<string, TagColor> = {
    neutral: TagColor.neutral,
    info: TagColor.malibu,
    warning: TagColor.champagne,
    positive: TagColor.lime,
    critical: TagColor.radical,
  }

  return typeMap[statusConfig.type] || TagColor.grey
}

export default function tagColor(
  incidenceStatus: string,
  isBookkeeperView: boolean,
  hasInhousePayroll: boolean
) {
  const TAG_COLORS: Record<string, TagColor> = {
    in_preparation: TagColor.champagne,
    'in-preparation': TagColor.champagne,
    to_do: TagColor.lime,
    'to-do': TagColor.lime,
    doing: TagColor.purple,
    done: TagColor.lime,
    discarded: TagColor.neutral,
  }

  const TAG_COLORS_INHOUSE: Record<string, TagColor> = {
    in_preparation: TagColor.champagne,
    'in-preparation': TagColor.champagne,
    to_do: TagColor.champagne,
    'to-do': TagColor.champagne,
    doing: TagColor.malibu,
    done: TagColor.lime,
    discarded: TagColor.neutral,
  }

  const TAG_COLORS_BK: Record<string, TagColor> = {
    in_preparation: TagColor.purple,
    'in-preparation': TagColor.purple,
    to_do: TagColor.radical,
    'to-do': TagColor.radical,
    doing: TagColor.champagne,
    done: TagColor.lime,
    discarded: TagColor.neutral,
  }

  if (isBookkeeperView) {
    return TAG_COLORS_BK[incidenceStatus] || TagColor.grey
  } else if (hasInhousePayroll) {
    return TAG_COLORS_INHOUSE[incidenceStatus] || TagColor.grey
  }
  return TAG_COLORS[incidenceStatus] || TagColor.grey
}

export const reopenedTagColor = () => TagColor.grey
